import { _Item } from "../items/types.js";
import { SharingRole, } from "./types.js";
import { shareWith, getShareLink, checkPermissions, getSharingInformation, getObjectSharingSettings, unshareObject, deleteLinkByKind, unshareLink, } from "./funcs.js";
_Item.prototype.shareWith = function (loginNames, role, requireSignin, emailData) {
    if (role === void 0) { role = SharingRole.View; }
    if (requireSignin === void 0) { requireSignin = false; }
    return shareWith(this, loginNames, role, requireSignin, false, emailData);
};
_Item.prototype.getShareLink = getShareLink;
_Item.prototype.checkSharingPermissions = checkPermissions;
_Item.prototype.getSharingInformation = getSharingInformation;
_Item.prototype.getObjectSharingSettings = getObjectSharingSettings;
_Item.prototype.unshare = unshareObject;
_Item.prototype.deleteSharingLinkByKind = deleteLinkByKind;
_Item.prototype.unshareLink = unshareLink;
//# sourceMappingURL=item.js.map